import type { HTMLAttributes } from 'react';
import styles from './StatusBadge.module.css';

export type StatusVariant = 'active' | 'inactive' | 'blocked' | 'pending' | 'enabled' | 'disabled';

export interface StatusBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /**
   * Status variant
   */
  variant: StatusVariant;
  /**
   * Text to display
   */
  children: string;
  /**
   * Size of the badge
   * @default 'md'
   */
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export function StatusBadge({
  variant,
  children,
  size = 'md',
  className,
  ...props
}: StatusBadgeProps) {
  const badgeClasses = [
    styles.badge,
    styles[variant],
    styles[size],
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses} {...props}>
      {children}
    </span>
  );
}

StatusBadge.displayName = 'StatusBadge';
